import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './infoGrupo.scss'
import Filter from './filter/filter'
import { filterHandle, listarInfoGrupo } from './redux/infoGrupoActions'
import Tabela from './tabela'
import { setInfoGrupo, setProjeto } from '../../../layout/redux/layoutActions'

export default () => {
  const dispatch = useDispatch()
  const { grupos, grupo, filters, sistema  } = useSelector(state=> state.layoutState)
  const { 
    totalAvaliacao, 
    filtersProvisorio, 
    projeto, 
    projetos 
  } = useSelector(state=> state.infoGrupoStateProdutos) 

  const nls = require(`../infoGrupo/nls/${sistema.idioma}.json`)
  
  useEffect(()=> {
    if (projeto.id) {
      if (filters.typeSelect) {
        dispatch(filterHandle({projetoID: projeto.id, grupo, params: filters, filtersProvisorio, typeSelect: filters.typeSelect}))
      } else {
        dispatch(listarInfoGrupo({projetoID: projeto.id, grupo, params: {TipoBusca: 'Ciclo', MesCliclo: '2023-01', Comparacao: true}}))
      }
    }
  }, [projeto, grupo])

  const handleFormFilter = (e) => {
    dispatch(setProjeto(e.value))
  }

  const handleGrupo = (e) => {
    dispatch(setInfoGrupo(e.value))
  }
  
  return (
    <div className='box-infoGrupo'>
      <div className='box-infoGrupo-topinfo'>
        <div>
          <div className='box-infoGrupo-topinfo-select'>
            <Select 
              name='projeto'
              label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          <div className='box-infoGrupo-topinfo-select'>
            {/* <label>Cliente: </label> 
            <span> {projeto?.empresa}</span> */}
          </div>

          {grupos && grupos.some(g => g?.name && g.name.trim() !== '') ? (
            <div className='box-infoGrupo-topinfo-select'>
              <Select 
                name='grupo'
                label={nls.grupo}
                options={grupos}
                selected={grupo}
                action={(e)=> handleGrupo(e)}
                selectedItem={false}
              />
            </div>
          ) : null}

        </div>
        <div className='box-infoGrupo-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />
      {totalAvaliacao !== 0 ? (
      <Tabela />
    ) : (
      <div className="box-infoGrupo-tabela box-content centro">
        <p>{nls.semdadosparaexibir}</p>
      </div>
    )}
  </div>
  )
}
